import {
    Stack, TextField, useTheme, Button, Container, Typography,
    Paper, Grid, Dialog, TableContainer, Table, TableHead,
    TableRow, TableCell, TableBody, TablePagination, IconButton,
    DialogTitle, DialogActions, Snackbar, Alert, LinearProgress, Autocomplete,
    FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Chip,
    Box
} from '@mui/material';
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragOverlay,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
    useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ReorderIcon from '@mui/icons-material/Reorder';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
    color: '#424242',
    fontWeight: '600',
});

// Sortable Table Row Component
const SortableTableRow = ({ grade, index }) => {
    console.log(grade,'grade');
    
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: grade.GradeId });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        backgroundColor: isDragging ? 'rgba(0, 0, 0, 0.08)' : 'inherit',
        zIndex: isDragging ? 999 : 'auto',
    };

    return (
        <TableRow
            ref={setNodeRef}
            style={style}
            hover
            sx={{
                transition: 'background-color 0.2s ease',
            }}
        >
            <TableCell 
                align="center" 
                {...attributes}
                {...listeners}
                sx={{
                    cursor: isDragging ? 'grabbing' : 'grab',
                    width: '80px'
                }}
            >
                <DragIndicatorIcon color="action" />
            </TableCell>
            <TableCell align="center" >
                <Chip 
                    label={index + 1} 
                    color="primary" 
                    size="small"
                    variant="outlined"
                />
            </TableCell>
            <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                {grade.GradeName}
            </TableCell>
            <TableCell align="center" >
                <Chip 
                    label={grade.Active === 'Y' ? 'Active' : 'Inactive'} 
                    color={grade.Active === 'Y' ? 'success' : 'error'} 
                    size="small"
                />
            </TableCell>
        </TableRow>
    );
};

const GradeMst = () => {
    const [token, setToken] = useState(
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const [open, setOpen] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [gradeData, setGradeData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [active, setActive] = useState('Y');
    const [processDescription, setProcessDescription] = useState('');
    const [operation, setOperation] = useState('Add');
    const [editID, setEditID] = useState();
    const [errors, setErrors] = useState({
        processDescription: false,
    });
    const [helperTexts, setHelperTexts] = useState({
        department: '',
        processDescription: '',
    });
    const [alertType, setAlertType] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const [openLoader, setOpenLoader] = useState(false);

    // Drag & Drop States
    const [isReorderMode, setIsReorderMode] = useState(false);
    const [reorderedGrade, setReorderedGrade] = useState([]);
    const [activeId, setActiveId] = useState(null);

    // Sensors for drag and drop
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    // API Integration
    useEffect(() => {
        getAllGradeData();
 
    }, []);

    // get all process data
    const getAllGradeData = async (processId = 0) => {
        setOpenLoader(true);
        try {
            const res = await axios.instance.get(`/GetAllGradeMst`, {
                headers: { Authorization: token, 'Content-Type': 'application/json' },
            });
            setGradeData(res.data);
            setReorderedGrade(res.data);

             
        } catch (error) {
            console.error('Error fetching process data:', error);
        }
        setOpenLoader(false);
          console.log('reorderedGrade', reorderedGrade);
               console.log('gradeData', gradeData);
    };

    // insert or update process
    const insertUpdateProcess = async (gradeData, operationType) => {
        try {
            await axios.instance.post(`/InsertGradeMstData`, gradeData, {
                headers: { Authorization: token, 'Content-Type': 'application/json' },
            });
            setOpenAlert(true);
            setEditID();
            getAllGradeData();
            setAlertType('success');
            setAlertMessage(`${operationType === 'New' ? 'Added Successfully!' : 'Updated Successfully!'}`);
        } catch (error) {
            console.error('Error updating process:', error);
            setAlertType('error');
            setAlertMessage('Failed to save process data.');
            setOpenAlert(true);
        }
    };

    // delete process
    const deleteProcess = async (processId) => {
        try {
            await axios.instance
                .delete(`/DeleteGradeMstData/${processId}`, {
                    headers: { Authorization: token, 'Content-Type': 'application/json' },
                })
                .then((res) => {
                    if (res.data === '') {
                        getAllGradeData();
                        setOpenDelete(false);
                        setAlertType('warning');
                        setAlertMessage('Deleted Successfully!');
                        setOpenAlert(true);
                    } else {
                        getAllGradeData();
                        setOpenDelete(false);
                        setAlertType('error');
                        setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
                        setOpenAlert(true);
                    }
                });
        } catch (error) {
            console.error('Error deleting process:', error);
            setAlertType('error');
            setAlertMessage('Failed to delete process.');
            setOpenAlert(true);
        }
    };

    // Drag & Drop Functions
    const handleDragStart = (event) => {
        setActiveId(event.active.id);
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;
        setActiveId(null);

        if (active.id !== over?.id) {
            setReorderedGrade((items) => {
                const oldIndex = items.findIndex((item) => item.GradeId === active.id);
                const newIndex = items.findIndex((item) => item.GradeId === over.id);
                
                const newItems = arrayMove(items, oldIndex, newIndex);
                
                // Update order numbers based on new positions
                return newItems.map((item, index) => ({
                    ...item,
                    OrderNumber: index + 1
                }));
            });
        }
    };

    const handleDragCancel = () => {
        setActiveId(null);
    };

    const saveNewOrder = async () => {
        setOpenLoader(true);
        try {
            // Send the entire reordered array to the backend
            const response = await axios.instance.post('/UpdateGradeOrder', reorderedGrade, {
                headers: { Authorization: token, 'Content-Type': 'application/json' },
            });
            
            setAlertType('success');
            setAlertMessage('Process order updated successfully!');
            setOpenAlert(true);
            setIsReorderMode(false);
            getAllGradeData(); // Refresh data
        } catch (error) {
            console.error('Error updating process order:', error);
            setAlertType('error');
            setAlertMessage('Failed to update process order.');
            setOpenAlert(true);
        }
        setOpenLoader(false);
    };

    const cancelReorder = () => {
        setIsReorderMode(false);
        setReorderedGrade(gradeData);
    };

    const enableReorderMode = () => {
        setIsReorderMode(true);
        // setReorderedGrade(filteredData);
    };

    // validation
    const validateForm = () => {
        const newErrors = {};
        const newHelperTexts = {};

        if (!processDescription || !processDescription.trim()) {
            newErrors.processDescription = true;
            newHelperTexts.processDescription = 'Please enter Process Description';
        }

        setErrors(newErrors);
        setHelperTexts(newHelperTexts);

        return Object.keys(newErrors).length === 0;
    };

    // submit button on add or edit
    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateForm()) {
            setIsFormSubmitted(true);
            return;
        }

        const processPayload = {
            optype: operation === 'Edit' ? 'Edit' : 'New',      
            GradeName: processDescription,
            Active: active,
            CreatedBy: sessionStorage.getItem('UserID'),
            ModifiedBy: sessionStorage.getItem('UserID'),
        };

        if (operation === 'Edit') {
            processPayload.GradeId = editID;
        }

        insertUpdateProcess(processPayload, operation);
        resetForm();
        handleClose();
    };

    const resetForm = () => {
        setProcessDescription('');
        setActive('Y');
        setErrors({
            department: false,
            processDescription: false,
        });
        setHelperTexts({
            department: '',
            processDescription: '',
        });
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === 'processDescription') {
            setProcessDescription(value);
        } else if (name === 'active') {
            setActive(value);
        }

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
            setHelperTexts(prev => ({ ...prev, [name]: '' }));
        }
    };

   
    const handleBlur = (event) => {
        const { name, value } = event.target;
        if (value.length > 0) {
            validateForm();
        }
    };

    // handle add popup dialog
    const handleAddOpen = () => {
        setOpen(true);
        setOperation('Add');
        resetForm();
    };

    // handle edit popup dialog
    const handleEdit = (data) => {
        setEditID(data.GradeId);
        setProcessDescription(data.GradeName || '');
        setActive(data.Active || 'Y');
          
        setOpen(true);
        setOperation('Edit');
    };

    // handle delete popup dialog
    const handleDelete = (processId) => {
        setOpenDelete(true);
        setDeleteId(processId);
    };

    const handleDeleteConfirmed = () => {
        deleteProcess(deleteId);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    const handleClose = () => {
        setOpen(false);
        resetForm();
    };

    // search & filter
    const filteredData = gradeData.filter((grade) =>
        grade.GradeName.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

    // pagination
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));

    // Reset page to 0 when searchTerm changes
    useEffect(() => {
        setPage(0);
    }, [searchTerm]);

    return (
        <>
            <Snackbar
                style={{ marginTop: '45px' }}
                open={openAlert}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
            >
                <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>

            <Container maxWidth={'xl'} elevation={3}>
                <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
                    <Typography
                        variant="h5"
                        p={1}
                        boxShadow={1}
                        borderColor="#11235A"
                        textAlign={'center'}
                        borderRadius={2}
                        pl={2}
                        color="white"
                        sx={{
                            background: 'linear-gradient(to right, #314755, #26a0da)',
                            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
                        }}
                    >
                        <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                            Grade Master
                        </Typography>
                    </Typography>
                </Grid>
                
                {/* search & add button */}
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
                    <TextField
                        type="text"
                        variant="outlined"
                        color="secondary"
                        label="Search"
                        size="small"
                        onChange={(e) => setSearchTerm(e.target.value)}
                        value={searchTerm}
                        sx={{ minWidth: 250 }}
                    />
                    
                    <Stack direction="row" spacing={2}>
                        {isReorderMode ? (
                            <>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={saveNewOrder}
                                    startIcon={<SaveIcon />}
                                    size="small"
                                >
                                    Save Order
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={cancelReorder}
                                    startIcon={<CancelIcon />}
                                    size="small"
                                >
                                    Cancel
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={enableReorderMode}
                                    startIcon={<ReorderIcon />}
                                    size="small"
                                >
                                    Reorder Grade
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    sx={{ boxShadow: 1 }}
                                    onClick={handleAddOpen}
                                    startIcon={<AddLocationAltRoundedIcon />}
                                    size="small"
                                >
                                    Add Grade
                                </Button>
                            </>
                        )}
                    </Stack>
                </Stack>

                {/* table  */}
                <TableContainer component={Paper} elevation={2} sx={{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }}>
                    {isReorderMode ? (
                        // Drag & Drop Table View with @dnd-kit
                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragStart={handleDragStart}
                            onDragEnd={handleDragEnd}
                            onDragCancel={handleDragCancel}
                        >
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" >Drag</StyledTableCell>
                                        <StyledTableCell align="center" >New Order</StyledTableCell>
                                        <StyledTableCell align="left">Grade</StyledTableCell>
                                        <StyledTableCell align="center" >Status</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <SortableContext 
                                        items={reorderedGrade.map(p => p.GradeId)} 
                                        strategy={verticalListSortingStrategy}
                                    >
                                        {reorderedGrade.map((grade, index) => (
                                            <SortableTableRow 
                                                key={grade.GradeId} 
                                                grade={grade} 
                                                index={index}
                                            />
                                        ))}
                                    </SortableContext>
                                </TableBody>
                            </Table>
                            <DragOverlay>
                                {activeId ? (
                                    <TableRow sx={{ 
                                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                        boxShadow: 2
                                    }}>
                                        <TableCell align="center">
                                            <DragIndicatorIcon color="action" />
                                        </TableCell>
                                        <TableCell align="center">
                                            <Chip 
                                                label={reorderedGrade.findIndex(p => p.GradeId === activeId) + 1} 
                                                color="primary" 
                                                size="small"
                                                variant="outlined"
                                            />
                                        </TableCell>
                                        <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                                            {reorderedGrade.find(p => p.GradeId === activeId)?.GradeName}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Chip 
                                                label={reorderedGrade.find(p => p.GradeId === activeId)?.Active === 'Y' ? 'Active' : 'Inactive'} 
                                                color={reorderedGrade.find(p => p.GradeId === activeId)?.Active === 'Y' ? 'success' : 'error'} 
                                                size="small"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ) : null}
                            </DragOverlay>
                        </DndContext>
                    ) : (
                        // Normal Table View
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">S.No</StyledTableCell>
                                    <StyledTableCell align="left">Grade</StyledTableCell>
                                    <StyledTableCell align="center">Status</StyledTableCell>
                                    <StyledTableCell align="center">Actions</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(rowsPerPage > 0
                                    ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : filteredData
                                ).map((grade, index) => (
                                    <TableRow key={grade.GradeId} hover>
                                        <TableCell align="center">
                                            {page * rowsPerPage + index + 1}
                                        </TableCell>
                                        <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                                            {grade.GradeName}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Chip 
                                                label={grade.Active === 'Y' ? 'Active' : 'Inactive'} 
                                                color={grade.Active === 'Y' ? 'success' : 'error'} 
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell align="center" sx={{ padding: '0' }}>
                                            <IconButton aria-label="Edit" onClick={() => handleEdit(grade)} size="small">
                                                <EditIcon color="primary" fontSize="small" />
                                            </IconButton>
                                            <IconButton aria-label="Delete" onClick={() => handleDelete(grade.GradeId)} size="small">
                                                <DeleteForeverIcon color="error" fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 53 * emptyRows }}>
                                        <TableCell colSpan={5} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    )}
                </TableContainer>

                {/* pagination - Only show in normal mode */}
                {!isReorderMode && (
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalRows}
                        rowsPerPage={rowsPerPage}
                        page={currentPage}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        onRowsPerPageChange={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        }}
                        sx={{ mt: 2 }}
                    />
                )}
            </Container>

            {/* Rest of your dialogs remain the same */}
            <Grid m={2}>
                {/* add/edit popup form dialog box */}
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth maxWidth="sm">
                    <Container component={Paper} elevation={2} sx={{ py: 2 }}>
                        <form onSubmit={handleSubmit} noValidate>
                            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                                <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                                    {operation} Grade
                                </Typography>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>
                            <Stack direction={'column'} spacing={2} p={2}>
                                
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    color="primary"
                                    label="Grade"
                                    name="processDescription"
                                    value={processDescription}
                                    onBlur={handleBlur}
                                    onChange={handleInputChange}
                                    fullWidth
                                    required
                                    size="small"
                                    error={errors.processDescription}
                                    // helperText={helperTexts.processDescription}
                                    helperText={
                                            processDescription.length > 5
                                            ? 'Maximum 5 characters allowed'
                                            : helperTexts.processDescription
                                        }
                                        inputProps={{ maxLength: 5 }} 

                                        />

                                <FormControl size="small" fullWidth component="fieldset">
                                    <FormLabel component="legend">Active Status</FormLabel>
                                    <RadioGroup row value={active} name="active" onChange={handleInputChange}>
                                        <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="N" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>

                                <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    type="submit"
                                    sx={{ textTransform: 'capitalize' }}
                                >
                                    {operation === 'Add' ? 'Add' : 'Update'} Grade
                                </Button>
                            </Stack>
                        </form>
                    </Container>
                </Dialog>

                {/* delete confirmation popup dialog box */}
                <Dialog
                    open={openDelete}
                    onClose={handleCloseDelete}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullScreen={fullScreen}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle id="alert-dialog-title">{'Are you sure you want to delete this process?'}</DialogTitle>
                    <DialogActions>
                        <Button variant="contained" onClick={handleCloseDelete} color="primary">
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={handleDeleteConfirmed} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>

            {/* loader popup dialog box */}
            <Dialog
                open={openLoader}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="xs"
            >
                <LinearProgress />
            </Dialog>
        </>
    );
};

export default GradeMst;